import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function CostComparison() {
  const rows = [{
    without: '3 hs de planificación × 40 semanas lectivas',
    cost: '120 horas de tu vida por año'
  }, {
    without: 'Evaluaciones sin criterios de corrección',
    cost: 'Domingos de corrección sin referencia'
  }, {
    without: 'Actividades copiadas de internet sin contexto rural',
    cost: 'Materiales que no encajan con tu realidad'
  }, {
    without: 'Temas como el IAPI o la sojización sin material adaptado',
    cost: 'Clases que no enganchan'
  }, {
    without: 'Grupos con distintos años sin sistema',
    cost: 'Alumnos que se pierden y no vuelven'
  }, {
    without: 'Domingo buscando en Google',
    cost: 'El mismo ciclo, el próximo año'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <div className="text-center mb-8" data-id="element-50">
          <h2 className="text-2xl md:text-4xl font-black text-white" data-id="element-51">
            <AlertTriangle className="w-6 h-6 md:w-8 md:h-8 inline mr-2 text-brand-accent" data-id="element-52" />
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="rounded-xl border border-white/10 overflow-hidden bg-brand-card" data-id="element-53">
          {/* Header row */}
          <div className="grid grid-cols-2 border-b border-white/10" data-id="element-54">
            <div className="px-3 py-2.5 md:px-4 md:py-3 bg-red-500/10 border-r border-white/5" data-id="element-55">
              <p className="text-xs md:text-sm font-bold text-red-400 text-center" data-id="element-56">
                ❌ Sin Kit Profe
              </p>
            </div>
            <div className="px-3 py-2.5 md:px-4 md:py-3 bg-red-500/10" data-id="element-57">
              <p className="text-xs md:text-sm font-bold text-red-400 text-center" data-id="element-58">
                💸 Costo real
              </p>
            </div>
          </div>

          {/* Data rows */}
          {rows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < rows.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-59">
              <div className="px-3 py-2.5 md:px-4 md:py-3 border-r border-white/5" data-id="element-60">
                <p className="text-[10px] md:text-sm text-gray-400" data-id="element-61">
                  {row.without}
                </p>
              </div>
              <div className="px-3 py-2.5 md:px-4 md:py-3 bg-red-500/5" data-id="element-62">
                <p className="text-[10px] md:text-sm text-red-400 font-bold" data-id="element-63">
                  {row.cost}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center space-y-4 mt-8" data-id="element-64">
          <h3 className="text-xl md:text-3xl font-black text-white" data-id="element-65">
            El próximo domingo puede ser diferente.
          </h3>
          <p className="text-base md:text-xl font-medium text-gray-500 italic max-w-2xl mx-auto" data-id="element-66">
            "El campo argentino tiene 500 años de historia. Tus alumnos merecen
            entenderla." 🌾
          </p>
        </div>
      </div>
    </section>;
}